<template>
    <div>
        <v-card class="pa-3 mx-4 mt-3">
            <v-layout
                row
                class="px-3 pt-3 pb-2 mb-2 ma-1"
                style="border: 2px solid #43a047; border-radius: 6px;"
            >
                <v-layout column style="width: 50%">
                    <div class="mb-3">
                        <v-layout row class="pa-0">
                            <div class="font-weight-medium mr-3">
                                {{ broadcast.broadcastName }}
                            </div>

                            <div
                                class="cyan caption pa-1"
                                style="color: #fff; padding-top: 5px !important;"
                            >
                                {{ broadcast.accountsSource }}
                            </div>
                            <div
                                style="background-color: #fdb400; padding-top: 5px !important;"
                                class="ml-2 caption pa-1 white--text"
                                v-if="
                                    broadcast.broadcastStatus != 'COMPLETED' &&
                                        broadcast.broadcastStatus != 'STOPPED'
                                "
                            >
                                {{ broadcast.broadcastStatus }}
                            </div>
                            <div
                                style="background-color: rgb(243, 81, 35); padding-top: 5px !important;"
                                class="ml-2 caption pa-1 white--text"
                                v-if="broadcast.broadcastStatus == 'STOPPED'"
                            >
                                {{ broadcast.broadcastStatus }}
                            </div>
                            <v-btn
                                class="my-0 ml-2 white--text"
                                style="height: 28px;"
                                color="danger"
                                dark
                                small
                                v-if="broadcast.broadcastStatus != 'STOPPED'"
                                @click="openStopBroadcast"
                                >Stop Broadcast</v-btn
                            ><v-btn
                                class="my-0 ml-2 white--text"
                                style="height: 28px; background-color: rgb(253, 180, 0)"
                                small
                                v-if="broadcast.broadcastStatus != 'SCHEDULED'"
                                @click="openRescheduleBroadcast"
                                >Reschedule</v-btn
                            >
                        </v-layout>
                        <div class="body-1">Name</div>
                    </div>
                    <div class="mb-3">
                        <div class="font-weight-medium">
                            {{ broadcast.fromNumber }}
                        </div>
                        <div class="body-1">Caller ID</div>
                    </div>
                    <div class="mb-3">
                        <div class="font-weight-medium">
                            {{ broadcast.userName }}
                        </div>
                        <div class="body-1">User</div>
                    </div>
                    <v-layout row>
                        <div class="mb-0">
                            <div class="font-weight-medium">
                                {{ broadcast.date | time }}
                            </div>
                            <div class="body-1">Date</div>
                        </div>
                        <div
                            class="mb-0 ml-4"
                            v-if="broadcast.date != broadcast.broadcastTime"
                        >
                            <div class="font-weight-medium d-flex align-center">
                                {{ broadcast.broadcastTime | time }}
                                <v-icon
                                    v-if="broadcast.broadcastStatus != 'COMPLETED'"
                                    small
                                    style="font-size: 18px; color: #43a047; cursor: pointer; margin-left: 4px;"
                                    @click="openUpdateBroadcastTime"
                                    >mdi-pencil</v-icon
                                >
                            </div>
                            <div class="body-1">Broadcast Time</div>
                        </div>
                    </v-layout>
                </v-layout>
                <v-layout column style="width: 50%">
                    <div class="mb-2">
                        <div class="font-weight-medium">
                            {{ broadcast.totalCount }}
                        </div>
                        <div class="body-1">Total Messages</div>
                    </div>

                    <v-layout row wrap class="my-1">
                        <div
                            class="mr-4"
                            v-for="status in getBroadcastStatuses()"
                        >
                            <div class="font-weight-medium">
                                {{ status.count }}
                            </div>
                            <div class="body-1">
                                {{ status.status.toUpperCase() }}
                            </div>
                        </div>
                    </v-layout>

                    <v-layout row class="">
                        <div class="font-weight-medium mr-2">Text:</div>
                        <div style="font-size: 13px" class="mt-0">
                            {{ broadcast.text }}
                        </div>
                    </v-layout>

                    <v-btn
                        style="width: 100px;"
                        color="success"
                        small
                        @click="reuseBroadcast(broadcast)"
                        >Reuse</v-btn
                    >
                </v-layout>
            </v-layout>
        </v-card>

        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :beforeSetupGrid="beforeSetupGrid"
            name="broadcast-message-logs-new"
            :isRemotePaging="false"
            :isRemoteSorting="false"
        ></dx-grid>

        <v-dialog v-model="stopBroadcastDialog" max-width="400">
            <v-card class="pa-3">
                <div v-if="!stopped">
                    <v-card-title class="headline pl-0 pt-0">
                        Are you sure?
                    </v-card-title>
                    <div class="mb-3">
                        This will abort the broadcast, all pending messages will
                        be cancelled
                    </div>
                    <v-card-actions class="mr-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="stopBroadcastDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn
                            color="danger"
                            class="white--text"
                            :loading="processing"
                            @click="stopBroadcast()"
                            >Stop</v-btn
                        >
                    </v-card-actions>
                </div>
                <div v-if="stopped">
                    <v-card-title class="headline pl-0">
                        Broadcast Stopped
                    </v-card-title>
                    <div class="mb-3">
                        <span class="font-weight-medium">{{
                            stopBroadcastResult.totalSent
                        }}</span>
                        of
                        <span class="font-weight-medium">{{
                            stopBroadcastResult.total
                        }}</span>
                        messages have already been delivered
                    </div>
                    <v-card-actions class="mr-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="stopBroadcastDialog = false"
                            >close</v-btn
                        >
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="rescheduleBroadcastDialog" max-width="400">
            <v-card class="pa-3">
                <div v-if="!rescheduled">
                    <v-card-title class="headline pl-0 pt-0">
                        Are you sure?
                    </v-card-title>
                    <div class="mb-3">
                        This will reschedule the broadcast, all pending messages
                        will be sent out
                    </div>
                    <v-card-actions class="mr-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="rescheduleBroadcastDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn
                            style="background-color: rgb(253, 180, 0)"
                            class="white--text"
                            :loading="processing"
                            @click="rescheduleBroadcast()"
                            >Reschedule</v-btn
                        >
                    </v-card-actions>
                </div>
                <div v-if="rescheduled">
                    <v-card-title class="headline pl-0">
                        Broadcast Rescheduled
                    </v-card-title>
                    <div class="mb-3">
                        <span class="font-weight-medium">{{
                            rescheduleBroadcastResult.totalPending
                        }}</span>
                        of
                        <span class="font-weight-medium">{{
                            rescheduleBroadcastResult.total
                        }}</span>
                        messages will be sent out
                    </div>
                    <v-card-actions class="mr-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="rescheduleBroadcastDialog = false"
                            >close</v-btn
                        >
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateBroadcastTimeDialog" max-width="450">
            <v-card class="pa-3">
                <div v-if="!updatedBroadcastTime">
                    <v-card-title class="headline pl-0 pt-0">
                        Update Broadcast Time
                    </v-card-title>
                    <v-text-field
                        v-model="updateBroadcastTimeValue"
                        label="New broadcast time"
                        type="datetime-local"
                    ></v-text-field>
                    <v-card-actions class="mr-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="updateBroadcastTimeDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn
                            color="success"
                            :disabled="!updateBroadcastTimeValue"
                            :loading="processing"
                            @click="updateBroadcastTime()"
                            >Update</v-btn
                        >
                    </v-card-actions>
                </div>
                <div v-if="updatedBroadcastTime">
                    <v-card-title class="headline pl-0">
                        Broadcast Time Updated
                    </v-card-title>
                    <v-card-actions class="mr-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="updateBroadcastTimeDialog = false"
                            >Close</v-btn
                        >
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Messages",
        url: "",
        broadcast: "",
        intervalID: "",
        stopBroadcastDialog: false,
        processing: false,
        stopped: false,
        stopBroadcastResult: {},
        rescheduleBroadcastDialog: false,
        rescheduled: false,
        rescheduleBroadcastResult: {},
        updateBroadcastTimeDialog: false,
        updateBroadcastTimeValue: "",
        updatedBroadcastTime: false,

        columns: [
            {
                field: "status",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "ERROR":
                        case "FAILED":
                            return "mdi-message-alert";
                        case "NEW":
                            return "mdi-message-plus";
                        case "QUEUED":
                        case "WAITING":
                        case "PENDING":
                            return "mdi-message-processing";
                        case "SENT":
                            return "mdi-comment-arrow-right";
                        case "UNKNOWN":
                            return "mdi-message-question";
                        case "DELIVERED":
                            return "mdi-message-text";
                        case "STOPPED":
                        case "UNDELIVERED":
                            return "mdi-close-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "ERROR":
                        case "FAILED":
                        case "STOPPED":
                        case "UNDELIVERED":
                            return "#f35123";
                        case "NEW":
                            return "info";
                        case "QUEUED":
                        case "WAITING":
                        case "PENDING":
                            return "#fdb400";
                        case "DELIVERED":
                            return "success";
                        case "SENT":
                        case "UNKNOWN":
                            return "#aeb8bf";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountId",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "dateTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Text",
                field: "text",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.loadBroadcast();
    },
    mounted() {
        this.intervalID = setInterval(() => {
            this.loadBroadcast();

            if (this.$refs && this.$refs.grid) {
                this.$refs.grid.reloadGrid();
            }
        }, 30000);
    },
    beforeDestroy() {
        clearInterval(this.intervalID);
    },
    methods: {
        beforeSetupGrid() {
            this.url = "broadcastMessages?broadcastID=" + this.$route.params.id;
        },
        async loadBroadcast() {
            const response = await this.$http.get(
                `/odata/broadcastReport?status=&$filter=(id eq ${
                    this.$route.params.id
                })`,
            );

            const broadcast = response.value[0];
            broadcast.statuses = await this.$http.get(
                "api/broadcast/getSmsStatuses?broadcastID=" + broadcast.id,
            );
            this.broadcast = broadcast;
        },
        async onRowClicked(row) {},
        getMessagesInProcess() {
            return this.broadcast.totalCount - (this.broadcast.completed || 0);
        },
        getBroadcastStatuses() {
            return this.broadcast.statuses;
        },
        reuseBroadcast(broadcast) {
            this.$router.push({
                name: "Broadcasts",
                query: {
                    reuseBroadcast: true,
                    broadcastID: this.broadcast.id,
                },
            });
            // this.$refs.broadcastDialog.loadDraft(broadcast.id.toString(), true);
        },
        openStopBroadcast() {
            this.stopBroadcastDialog = true;
        },
        openRescheduleBroadcast() {
            this.rescheduleBroadcastDialog = true;
        },
        openUpdateBroadcastTime() {
            this.updateBroadcastTimeDialog = true;
            this.updatedBroadcastTime = false;
            this.updateBroadcastTimeValue = moment(
                this.broadcast.broadcastTime || this.broadcast.date || new Date(),
            ).format("YYYY-MM-DDTHH:mm");
        },
        getBroadcastDomain() {
            return window.location.origin.startsWith("http://localhost")
                ? "https://localhost:7197/"
                : "https://broadcast-3t6ck5zrrq-ue.a.run.app/";
        },
        async stopBroadcast() {
            try {
                this.processing = true;

                const domain = this.getBroadcastDomain();

                const response = await this.$http.post(
                    domain +
                        "broadcast/stopBroadcast?id=" +
                        this.$route.params.id,
                );

                this.stopped = true;
                this.stopBroadcastResult = response;
                this.processing = false;
                this.loadBroadcast();
            } catch (e) {
                this.processing = false;
            }
        },
        async rescheduleBroadcast() {
            try {
                this.processing = true;

                const domain = this.getBroadcastDomain();

                const response = await this.$http.post(
                    domain +
                        "broadcast/rescheduleBroadcast?broadcastID=" +
                        this.$route.params.id,
                );

                this.rescheduled = true;
                this.rescheduleBroadcastResult = response;
                this.processing = false;
                this.loadBroadcast();
            } catch (e) {
                this.processing = false;
            }
        },
        async updateBroadcastTime() {
            try {
                this.processing = true;

                const domain = this.getBroadcastDomain();
                const newTime = moment(this.updateBroadcastTimeValue).format(
                    "YYYY-MM-DDTHH:mm:ss",
                );
                const response = await this.$http.post(
                    `${domain}broadcast/updateBroadcastTime?broadcastID=${
                        this.$route.params.id
                    }&newTime=${encodeURIComponent(newTime)}`,
                );

                this.updatedBroadcastTime = true;
                this.processing = false;
                this.loadBroadcast();
                return response;
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style></style>
